<template>
  <section class="user-dash__docs card mt-4">
    <div class="card-body mx-lg-4">
      <h2 class="heading-secondary">Documents à télécharger</h2>
      <div class="accordion my-3" id="accordionDocs">
        <div class="card my-2" v-for="root in documents" :key="'root-' + root.id">

          <!-- Nom des roots -->
          <div class="accordion__header" id="heading-1">
            <h5 class="text-uppercase mb-0">
              <a role="button" class="accordion__header-link accordion__link collapsed d-flex align-items-center px-3 px-lg-4 py-2" data-toggle="collapse" :href="'#collapse-' + root.id" aria-expanded="true">
                {{ root.name }}
                <i class="accordion__chevron fa fa-chevron-down ml-auto" :class="'text-' + $mainColor" aria-hidden="true"></i>
              </a>
            </h5>
          </div>

          <!-- Dossiers dans les roots -->
          <div :id="'collapse-' + root.id" class="collapse" data-parent="#accordionDocs" aria-labelledby="heading-1" v-if="root.children.length">
            <div id="accordionDocs-1" class="py-2">
              <div v-for="child in root.children" :key="'child-' + child.id">
                <h6 class="mb-0" id="heading-1-1">
                  <a role="button" class="accordion__link collapsed d-flex align-items-center px-3 px-lg-4 py-2" data-toggle="collapse" :href="`#collapse-${root.id}-${child.id}`" aria-expanded="false">
                    <i class="accordion__sub-chevron fa fa-chevron-right mr-2" :class="'text-' + $mainColor" aria-hidden="true"></i>
                    {{ child.name }}
                  </a>
                </h6>

                <!-- Sous-dossiers -->
                <div :id="`collapse-${root.id}-${child.id}`" class="collapse pl-4 pl-lg-5 px-3" data-parent="#accordionDocs-1" aria-labelledby="heading-1-1">
                  <div :id="'collapse-' + child.id" data-parent="#accordionDocs-1" aria-labelledby="heading-1-1" v-if="child.children.length">
                    <div id="accordionDocs-2" class="py-2">
                      <div v-for="childer in child.children" :key="'childer-' + childer.id">
                        <h6 class="mb-0" id="heading-1-1-1">
                          <a role="button" class="accordion__link collapsed d-flex align-items-center px-3 px-lg-4 py-2" data-toggle="collapse" :href="`#collapse-${child.id}-${childer.id}`" aria-expanded="false">
                            <i class="accordion__sub-chevron fa fa-chevron-right mr-2" :class="'text-' + $mainColor" aria-hidden="true"></i>
                            {{ childer.name }}
                          </a>
                        </h6>
                        <div :id="`collapse-${child.id}-${childer.id}`" class="collapse pl-4 pl-lg-5 px-3" data-parent="#accordionDocs-2" aria-labelledby="heading-1-1-1">
                          <a :href="childer_doc.file_url" target="_blank" class="text-primary thin d-block py-1" v-for="childer_doc in childer.documents" :key="'childer_doc-' + childer_doc.id">
                            <i class="fa fa-eye mr-h" aria-hidden="true"></i>
                            {{ childer_doc.name }}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <a :href="doc.file_url" target="_blank" class="text-primary thin d-block py-1" v-for="doc in child.documents" :key="'doc-' + doc.id">
                    <i class="fa fa-eye mr-h" aria-hidden="true"></i>
                    {{ doc.name }}
                  </a>
                </div>
              </div>
            </div>
          </div>
          <!-- Documents directement dans les roots -->
          <div :id="'collapse-' + root.id"  class="collapse pl-4 pl-lg-5 px-3" data-parent="#accordionDocs" aria-labelledby="heading-1" v-if="root.documents.length">
            <div id="accordionDocs-1" class="py-2">
              <a :href="doc.file_url" target="_blank" class="text-primary thin d-block py-1" v-for="doc in root.documents" :key="'doc-' + doc.id">
                <i class="fa fa-eye mr-h" aria-hidden="true"></i>
                {{ doc.name }}
              </a>
              <a :href="video.video_url" target="_blank" class="text-primary thin d-block py-1" v-for="video in root.videos" :key="'video-' + video.id">
                <i class="fa fa-video-camera mr-h" aria-hidden="true"></i>
                {{ video.name }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Documents',
  computed: {
    ...mapState(['documents'])
  }
}
</script>
